import React, { useState, useContext } from "react";
import tabs from "./data/listofroom/ListOfRoom";
import TabOfRoom from "./components/tabofroom/TabOfRoom";
import "../src/Main.scss";
import Loading from "./components/loading/Loading";
import { AppContext } from "./App";

const Main = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { dataPrices, dataProducts } = useContext(AppContext);

  // button change tab
  const changeTab = (index) => {
    setActiveTab(index);
  };
  
  

  return (
    <div>
      {dataPrices.Price === undefined  || dataProducts.length === undefined ? (
        <div className="parent-container">
          <div className="frame-loading">
            <Loading />
          </div>
        </div>
      ) : (
        <>
          <div className="frame-button-room">
            {tabs.map((tab, index) => (
              <button
                className={`button-tab-room ${
                  index === activeTab ? "active-room" : ""
                }`}
                key={index}
                onClick={() => changeTab(index)}
              >
                {tab.title}
              </button>
            ))}
          </div>
          <div className="layout-room">
            {tabs.map((tab, index) => (
              <TabOfRoom
                key={index}
                title={tab.title}
                content={tab.content}
                isActive={index === activeTab}
                id={tab.id}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Main;
